enum ISOFormat {
    Date = 'yyyy-MM-dd',
    Milliseconds = "yyyy-MM-dd'T'HH:mm:ss.SSS",
    Month = 'yyyy-MM',
    Seconds = "yyyy-MM-dd'T'HH:mm:ss",
    TimeSeconds = 'HH:mm:ss',
    TimeMilliseconds = 'HH:mm:ss.SSS',
    UtcMilliseconds = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
    UtcSeconds = "yyyy-MM-dd'T'HH:mm:ss'Z'",
    Year = 'yyyy',
}

export default ISOFormat;
